import { logger as dashingUILogger } from '@dashhudson/dashing-ui/logger';
import isError from 'lodash/isError';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';

/**
 * Plain object context for log entries. The `stack` constraint prevents
 * accidentally passing an Error where a context object is expected —
 * the mistake the runtime check below also catches.
 */
type MessageContext = Record<string, unknown> & { stack?: never };

function checkArguments(message?: string, messageContext?: MessageContext, error?: unknown) {
  if (message && !isString(message)) {
    throw Error('logger message must be a string');
  }
  if (messageContext && (!isObject(messageContext) || isError(messageContext))) {
    throw Error('logger messageContext must be an object and not an error');
  }
  if (error && !isError(error)) {
    throw Error('logger error must be an Error instance');
  }
}

export const logger = {
  debug(message: string, messageContext?: MessageContext, error?: unknown) {
    checkArguments(message, messageContext, error);
    return dashingUILogger.debug(message, messageContext, error as Error);
  },
  info(message: string, messageContext?: MessageContext, error?: unknown) {
    checkArguments(message, messageContext, error);
    return dashingUILogger.info(message, messageContext, error as Error);
  },
  warn(message: string, messageContext?: MessageContext, error?: unknown) {
    checkArguments(message, messageContext, error);
    return dashingUILogger.warn(message, messageContext, error as Error);
  },
  error(message: string, messageContext?: MessageContext, error?: unknown) {
    checkArguments(message, messageContext, error);
    return dashingUILogger.error(message, messageContext, error as Error);
  },
};
